import script from "./PriceRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceRow.vue?vue&type=script&setup=true&lang=ts"

import "./PriceRow.vue?vue&type=style&index=0&id=5f15aeea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f15aeea"]])

export default __exports__